module.exports = __webpack_public_path__ + "media/webfonts/fa-v4compatibility-52eba2c5.ttf";